export const SCAN_CODE_DELAY = 1000;
